import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import { type ExperienceTrackerAPI } from '@atlassian/conversation-assistant-instrumentation/main';

import { createAifcExperienceCollect } from './create-aifc-experience-collect';

type StartAifcGenerateContentExperiencesParams = {
	experienceTracker: ExperienceTrackerAPI;
	conversationId: string;
	attributes: Record<string, unknown>;
};

/**
 * Starts AIFC_GENERATE_CONTENT and its child experiences. Child experiences inherit the parent's
 * attributes.
 *
 * - AIFC_GENERATE_CONTENT mirrors AIFC_ALL_DATA_HANDLED via collect, and fails if
 *   AIFC_INITIAL_DATA_RECEIVED fails (timeout or error).
 * - AIFC_ALL_DATA_HANDLED and AIFC_INITIAL_DATA_RECEIVED are succeeded by the product AIFC
 *   integration.
 */
export const startAifcGenerateContentExperiences = ({
	experienceTracker,
	conversationId,
	attributes,
}: StartAifcGenerateContentExperiencesParams): void => {
	const childAttributes = {
		...attributes,
		parentExperienceId: ExperienceName.AIFC_GENERATE_CONTENT,
	};

	experienceTracker.start({
		name: ExperienceName.AIFC_GENERATE_CONTENT,
		id: conversationId,
		collect: createAifcExperienceCollect(),
		attributes,
	});
	experienceTracker.start({
		name: ExperienceName.AIFC_ALL_DATA_HANDLED,
		id: conversationId,
		attributes: childAttributes,
	});
	experienceTracker.start({
		name: ExperienceName.AIFC_MESSAGE,
		id: conversationId,
		attributes: childAttributes,
	});
	experienceTracker.start({
		name: ExperienceName.AIFC_INITIAL_DATA_RECEIVED,
		id: `${conversationId}-initial`,
		attributes: childAttributes,
	});
};
